<template>
  <div>
    <nav
      :style="styles.nav"
    >
      <button @click="goBack" class="button__action">
        &larr; Back
      </button>
      <div :style="styles.navInputWrapper">
        <i
          class="glyphicon glyphicon-search"
          :style="styles.navInputIcon"
        ></i>
        <input
          :style="styles.navInput"
          type="text"
          ref="searchInput"
          v-model="searchQuery"
          @keyup="searchMedia"
          placeholder="Search by title, description, filename..."
        />
      </div>
    </nav>
    <div id="mediaLibraryContainer" :style="styles.libraryWrapper">
      <LibraryGrid v-if="mediaItems.length">
          <MediaCard
            :contentType="media.contentType"
            :title="media.title"
            :key="index"
            :id="media._id"
            :onClick="selectActiveMedia"
            :media="media"
            :src="media.thumbnail"
            v-for="(media, index) in mediaItems"
          />
      </LibraryGrid>
    </div>
  </div>
</template>

<script>
import {getResource} from '../../services/Utils.js';
import Services from '../../services/Services.js';
import LibraryGrid from '../general/LibraryGrid.vue';
import MediaCard from '../general/MediaCard.vue';
export default {
  name: 'mediaSearch',
  components: {
    LibraryGrid,
    MediaCard,
  },
  data() {
    return {
      searchQuery: '',
      selectActiveMedia: Services.selectActiveMedia,
      mediaItems: [],
      styles: {
        libraryWrapper: {
          background: '#f5f5f5',
          paddingBottom: '20px',
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          borderBottom: '1px solid #eee',
          boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '100%',
          padding: '10px',
          margin: 'auto 0 auto auto',
          background: '#fff',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          margin: 'auto 0',
          borderRadius: '0',
          border: '0',
          background: '#fff',
        },
        navInputIcon: {
          margin: 'auto 20px auto 15px',
          color: '#09a3ed',
          fontSize: '1em',
          position: 'relative',
          top: '-1px',
        },
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    searchMedia() {
      const query = this.searchQuery;
      if (this.searchQuery === '') {
        this.mediaItems = [];
        return false
      }
      getResource('/v1/media/search', `term=${encodeURIComponent(query)}`)
        .then((res) => {
          this.mediaItems = res.media;
        })
        .catch(error => console.log(error));
    },
  },
  mounted() {
    this.$refs.searchInput.focus();
  }
}
</script>
<style lang="scss" scoped>
.rule__control-group.rule__control-group--select:after {
top: 12px;
}

#mediaLibraryContainer .mediaCard {
  width: calc(20% - 20px);
  @media all and (max-width: 1600px) {
    height: 200px;
    width: calc(25% - 20px);
  }
  @media all and (max-width: 1280px) {
    height: 200px;
    width: calc(33.33% - 20px);
  }
  @media all and (max-width: 996px) {
    height: 150px;
    width: calc(50% - 20px);
  }

  @media all and (max-width: 640px) {
    width: calc(100% - 20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/SearchMediaLibrary.vue